
import Vue from "vue";

export default Vue.extend({
  methods: {
    async signout() {
      await this.$store.dispatch("auth/logout");
      this.$router.push({ name: "login" });
    },
    clickListener(e: MouseEvent) {
      const target = e.target as HTMLElement;
      if (!target.closest(".user-menu") && !target?.closest(".avatar")) {
        this.$emit("close");
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.clickListener);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.clickListener);
  },
});
